export default __webpack_public_path__ + "static/media/no-data.4ffa903a.svg";